"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _machineIcons = require("./attrs/machineIcons");
var _sensorStatus = require("./attrs/sensorStatus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getSensorStatusProps = function getSensorStatusProps(value) {
  return _sensorStatus.SENSOR_STATUS_MAP.find(function (item) {
    return item.value === value;
  }) || _sensorStatus.SENSOR_STATUS_MAP[0];
};
var MachineIcon = function MachineIcon(_ref) {
  var fontSize = _ref.fontSize,
    color = _ref.color,
    iconName = _ref.iconName,
    status = _ref.status,
    style = _ref.style,
    viewBox = _ref.viewBox;
  var iconStyle = {
    color: getSensorStatusProps(status).color
  };
  return /*#__PURE__*/_react["default"].createElement(_material.SvgIcon, {
    fontSize: fontSize,
    color: color,
    viewBox: viewBox,
    style: _objectSpread(_objectSpread({}, style), iconStyle)
  }, _machineIcons.MACHINE_ICONS[iconName](iconStyle.color ? iconStyle.color : color));
};
MachineIcon.propTypes = {
  iconName: _propTypes["default"].oneOf(['idle', 'error', 'maintenance', 'missingLink', 'running', 'warning', 'sensorCurrent', 'sensorDensity', 'sensorEnergy', 'sensorFlow', 'sensorLevel', 'sensorOperatingHours', 'sensorPower', 'sensorPressure', 'sensorSpeed', 'sensorTemperature', 'sensorTime', 'sensorValve', 'sensorViscosity', 'sensorAngle', 'sensorConcentration', 'sensorDistance', 'sensorForce', 'sensorPosition', 'sensorProgress', 'sensorQuantity', 'sensorTorque', 'sensorVibration', 'sensorVolume', 'sensorWeight', 'sensorHourMeter', 'sensorPercentage', 'sensorFrequency']).isRequired,
  fontSize: _propTypes["default"].string,
  color: _propTypes["default"].string,
  status: _propTypes["default"].string,
  style: _propTypes["default"].shape({}),
  viewBox: _propTypes["default"].string
};
MachineIcon.defaultProps = {
  fontSize: 'default',
  color: 'inherit',
  status: null,
  style: {},
  viewBox: '0 0 24 24'
};
var _default = exports["default"] = MachineIcon;